import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import cx from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import MuiButton from '@material-ui/core/Button';
import MuiButtonGroup from '@material-ui/core/ButtonGroup/ButtonGroup';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Popover from '@material-ui/core/Popover';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Button from './Button';

const useStyles = makeStyles(theme => ({
  root: {
    border: `1px solid ${theme.palette.grey[400]}`
  },
  primaryButtonRoot: {
    fontSize: '0.75rem',
    borderRadius: 0,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  arrowDownButton: {
    borderLeft: `1px solid ${theme.palette.grey[400]}`,
    minWidth: '36px',
    color: theme.palette.grey[600],
    '&:hover': {
      borderColor: theme.palette.grey[400]
    }
  },
  menuItemRoot: {
    fontSize: '0.875rem'
  }
}));

// Format menuItems:
// { text: '...', route: '...' }
const ButtonGroup = ({ route, menuItems = [], children, classes = {} }) => {
  const localClasses = useStyles();
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const pushRoute = gotoRoute => {
    history.push(gotoRoute);
  };

  if (menuItems.length === 0) {
    return (
      <Button route={route} classes={classes}>
        {children}
      </Button>
    );
  }

  // Popover used instead of Popper as it doesn't work properly with tables
  return (
    <>
      <MuiButtonGroup
        variant="outlined"
        color="primary"
        ref={anchorRef}
        aria-label="split button"
        classes={{ root: cx(localClasses.root, classes.root) }}
      >
        <MuiButton
          variant="text"
          color="primary"
          onClick={() => {
            pushRoute(route);
          }}
          classes={{ root: localClasses.primaryButtonRoot }}
        >
          {children}
        </MuiButton>
        <MuiButton
          variant="text"
          size="small"
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-label="open menu with more options"
          aria-haspopup="menu"
          onClick={handleToggle}
          classes={{ root: localClasses.arrowDownButton }}
        >
          <ArrowDropDownIcon />
        </MuiButton>
      </MuiButtonGroup>
      <Popover
        id={open ? 'simple-popover' : undefined}
        open={open}
        anchorEl={anchorRef.current}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <MenuList id="split-button-menu">
          {menuItems.map(menuItem => {
            return (
              <MenuItem
                key={menuItem.text}
                onClick={() => {
                  pushRoute(menuItem.route);
                }}
                classes={{ root: localClasses.menuItemRoot }}
              >
                {menuItem.text}
              </MenuItem>
            );
          })}
        </MenuList>
      </Popover>
    </>
  );
};

export default ButtonGroup;
